module.exports = new __parcel__URL__("post-incident-reviews.28e33ce7.svg").toString();